export const phq9_catalog = [
    "1. Poco interés o placer en hacer cosas",
    "2. Sintiéndose decaído(a), deprimido(a), o sin esperanzas",
    "3. Dificultad en caer o permanecer dormido(a), o dormir demasiado",
    "4. Sintiéndose cansado o teniendo poca energía",
    "5. Pobre de apetito o comer en exceso",
    "6. Sintiéndose mal con usted mismo(a) - o que usted es un fracaso o que ha quedado mal con usted mismo(a) o con su familia",
    "7. Dificultad en concentrarse en cosas, tales como leer el periódico o ver televisión",
    "8. ¿Moviéndose o hablando tan lento, que otras personas podrían notarlo? O lo contrario - muy inquieto(a) o agitado(a) que usted ha estado moviéndose mucho más de lo normal",
    "9. Pensamientos de que usted estaría mejor muerto(a) o de alguna manera lastimándose a usted mismo(a)",
]